/* eslint-disable no-nested-ternary */
// @vue/component
export default {
  name: 'ConnectionType',

  props: {
    connectionTypesMap: {
      type: Object,
      default: () => ({}),
    },
    activeTypes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      connectionTypeNames: [],
    };
  },

  methods: {
    getLighterColor(colorValue) {
      const color = require('color');
      return color(colorValue).lighten(0.3);
    },
    getDarkenColor(colorValue) {
      const color = require('color');
      return color(colorValue).darken(0.4);
    },
  },
};
